(() => {
    document.addEventListener('DOMContentLoaded', () => {
        const swiperElements = document.querySelectorAll('.swiper.swiper-noticias-carrusel-fl');
        
        swiperElements.forEach(swiperElement => {
            const autoplay = swiperElement.dataset.autoplay === 'true';
            const delay = parseInt(swiperElement.dataset.delay) || 3000;
            
            const swiper = new Swiper(swiperElement, {
                mousewheel: true,
                loop: true,
                autoplay: autoplay ? { delay: delay } : false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        });
    });
})()